export default "__VITE_ASSET__zju_1kIK__"